import { areAttachmentsFullyRejected, isDocumentReady } from '@views/ProofDocuments/utils';

export const totalInvalidDocuments = (documents) => documents
  .filter((document) => areAttachmentsFullyRejected(document))
  .length;

export const totalDocuments = (documents) => documents
  .filter((document) => isDocumentReady(document))
  .length;
